import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { BsRootModule } from 'ngx-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxPaginationModule} from 'ngx-pagination';
import {MatRadioModule} from '@angular/material'
import * as $ from 'jquery';
import * as _ from 'lodash';
import * as bootstrap from "bootstrap";
import { ToasterModule } from 'angular2-toaster';
import { LoggerModule, NgxLoggerLevel, NGXLogger } from 'ngx-logger';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { MaterialModule } from './shared/MaterialModule';
import { BusyModule } from 'angular2-busy';
import { HttpModule } from '@angular/http';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { TabsComponent } from './components/home/tabs.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { DynamicTabsDirective } from './components/home/dynamic-tabs.directive';
import { dynamicModule } from './components/home/dynamic.module';
import { AuthGuard } from './guards/auth.guard';
import { APP_PROVIDERS } from './services/index';
import {StoreModule} from '@ngrx/store';
//import * as fromRootStore from './reducers';
import { reducers, metaReducers } from './reducers/index';
import {EffectsModule} from '@ngrx/effects';
import 'bootstrap';
//import { AgGridModule } from 'ag-grid-angular';




@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        HomeComponent,
        TabsComponent,
        DynamicTabsDirective
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        routing,
        
        BsRootModule,
        HttpModule,
        FormsModule, 
        MatRadioModule,
        NgxPaginationModule,
        ReactiveFormsModule,
        MaterialModule,
        dynamicModule,
        NgxDatatableModule,
        ToasterModule,
        BusyModule,
       // AgGridModule.withComponents([]),
        StoreModule.forRoot(reducers, { metaReducers }),
        StoreDevtoolsModule.instrument({
            maxAge: 25 //  Retains last 25 states
        }),
		EffectsModule.forRoot([]),
        LoggerModule.forRoot({ serverLoggingUrl: '/api/logs/uiLogs', level: NgxLoggerLevel.DEBUG, serverLogLevel: NgxLoggerLevel.ERROR })
    ],
    exports: [dynamicModule],
    entryComponents: [
    
    ],
    providers: [
        APP_PROVIDERS,
        AuthGuard,
        NGXLogger
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/app.module.ts